export default __webpack_public_path__ + "static/media/costarica.28af3ec0.png";